// eslint-disable-next-line import/no-unresolved
import KeenSlider from './keen-slider-with-wheel.js'

if (!customElements.get('product-size-tabs')) {
  customElements.define(
    'product-size-tabs',
    class ProductSizeTabs extends window.BAO.CustomElement {
      constructor () {
        super()

        if (this.els.trigger.elements.length < 2) return

        this.initialiseTabs()
        this.initialiseCarousels()
      }

      setupListeners () {
        super.setupListeners()

        if (!this.els.modelTrigger) return

        this.handleMouseEnter = this.handleMouseEnter.bind(this)

        this.els.modelTrigger.elements.forEach(modelTrigger => {
          this.listeners.add(modelTrigger, 'mouseenter', this.handleMouseEnter)
        })
      }

      initialiseTabs () {
        this.els.trigger.elements.forEach(triggerEl => {
          triggerEl.addEventListener('click', this.handleTrigger.bind(this))
        })
      }

      handleTrigger = event => {
        const name = event.currentTarget.dataset.productSizeTabsName
        const tab =
          this.querySelector(
            `.prd-SizeGuideDrawer_Tab[data-product-size-tabs-name="${name}"]`,
          ) || event.currentTarget

        this.els.trigger.elements.forEach(triggerEl => {
          if (
            triggerEl.classList.contains('prd-SizeGuideDrawer_Tab') ||
            !this.querySelector('.prd-SizeGuideDrawer_Tab')
          ) {
            triggerEl.setAttribute('aria-pressed', triggerEl === tab)
          }
        })
        this.els.content.elements.forEach(contentEl =>
          contentEl.setAttribute(
            'aria-expanded',
            contentEl.dataset.productSizeTabsContent === name,
          ),
        )
      }

      initialiseCarousels () {
        if (!this.els.modelImages) return

        this.els.modelImages.elements.forEach(modelImage => {
          const modelCarouselEl = modelImage.querySelector(
            '[data-product-size-tabs-el="modelCarousel"]',
          )
          if (modelCarouselEl) {
            const modelDotEls = modelImage.querySelectorAll(
              '[data-product-size-tabs-el="dot"]',
            )

            modelCarouselEl.setAttribute(
              'data-custom-cursor-external-el',
              'carousel',
            )

            this.modelKeenSlider = new KeenSlider(modelCarouselEl, {
              duration: 1000,
              loop: true,
              mode: 'snap',
              slidesPerView: 1,
              slides: '.car-Carousel_Slide',
              slideChanged: instance => {
                modelDotEls.forEach(dot => {
                  dot.setAttribute(
                    'aria-current',
                    parseInt(dot.dataset.slide) ===
                      instance.details().relativeSlide,
                  )
                })
              },
            })
          }
        })
      }

      handleMouseEnter (event) {
        const modelName = event.target.dataset.model

        this.els.modelImages.elements.forEach(modelImageEl => {
          modelImageEl.setAttribute(
            'aria-hidden',
            modelImageEl.dataset.model !== modelName,
          )

          this.els.modelTrigger.elements.forEach(modelTrigger => {
            modelTrigger.setAttribute(
              'aria-pressed',
              modelTrigger.dataset.model === modelName &&
                modelTrigger.dataset.mainTrigger === 'true',
            )
          })
        })
      }
    },
  )
}
